export default __webpack_public_path__ + "static/media/deliverby.c659840d.svg";